import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, withTheme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Moment from 'moment'
import { DatePicker } from 'material-ui-pickers'
import {
  getOptionsDataAndSms
} from '../../subscriptions/containers/graph-options'
import Y from '../../../y18n'
import * as graphActions from '../../../store/subscriptions-admin/graph'
import Styles from '../../../common/styles'
import ScrollLine from '../../subscriptions/containers/scroll-line'

const mapStateToProps = state => ({
  graph: state.subscriptionsAdmin.graph
})

const mapDispatchToProps = dispatch => ({
  graphActions: bindActionCreators(graphActions, dispatch)
})

class DataGraph extends Component {
  state = {
    id: '',
    fromDate: Moment.utc(new Date()).add(-31, 'days').format(),
    toDate: Moment.utc(new Date()).format()
  }

  componentDidMount () {
    if (this.props.id) {
      this.props.graphActions.getDataGraph(
        this.props.id,
        this.state.fromDate,
        this.state.toDate
      )
      this.setState({ id: this.props.id })
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.submit()
  }

  submit = () => {
    this.props.graphActions.getDataGraph(
      this.state.id,
      this.state.fromDate,
      this.state.toDate
    )
  }

  handleDateChange = (e, name) => {
    this.setState({ [name]: e._d }, () => this.submit())
  }

  render () {
    const { classes, graph, id, theme } = this.props
    const { fromDate, toDate } = this.state
    if (!id) return null

    const dataSet = this.getDataset(theme.palette.primary.main)
    const options = getOptionsDataAndSms()

    options.animation = {
      duration: 100,
      onComplete: () => this.extractAxes(),
      onProgress: () => this.clearCanvasAxes()
    }

    return (
      <div style={{ marginTop: '40px' }}>
        <div className={classes.textRow}>
          <Typography variant='title'>
            {Y`Data graph`}
          </Typography>
          <Typography variant='body2'>
            {Y`Change the fields for 'From date' and 'To date' if you want to change the current selection`}
          </Typography>
        </div>
        <Paper id='graphContainer'>
          {graph.loading && <LinearProgress />}
          <div className={classes.content}>
            <form onSubmit={e => this.handleSubmit(e)}>
              <div className={classes.flexRow}>
                <DatePicker
                  keyboard
                  clearable
                  className={classes.flexItemLeft}
                  animateYearScrolling={false}
                  label={Y`From date`}
                  format='YYYY-MM-DD'
                  value={fromDate}
                  onChange={e => this.handleDateChange(e, 'fromDate')}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  InputAdornmentProps={{
                    classes: {
                      root: classes.rightIcon
                    }
                  }}
                />
                <DatePicker
                  keyboard
                  clearable
                  className={classes.flexItemRight}
                  animateYearScrolling={false}
                  label={Y`To date`}
                  format='YYYY-MM-DD'
                  value={toDate}
                  onChange={e => this.handleDateChange(e, 'toDate')}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  InputAdornmentProps={{
                    classes: {
                      root: classes.rightIcon
                    }
                  }}
                />
              </div>
            </form>
          </div>
          <div className={classes.graph}>

            {graph && graph.graph
              ? <ScrollLine
                dataSet={dataSet}
                options={options}
                height={400}
                minWidth={930}
                />
              : ''}
          </div>
        </Paper>
      </div>
    )
  }

  getDataset (themeColor) {
    return {
      labels: this.props.graph.graph.dates.map(date =>
        new Moment(date).format('YYYY-MM-DD')
      ),
      datasets: [
        {
          label: '(' + Y`Remaining data` + ' (MB',
          backgroundColor: `${themeColor}33`,
          borderColor: themeColor,
          borderWidth: 1,
          pointBackgroundColor: themeColor,
          hoverBackgroundColor: `${themeColor}66`,
          hoverBorderColor: themeColor,
          data: this.props.graph.graph.data.map(data =>
            data.toFixed(2)
          ),
          lineTension: 0,
          yAxisID: 'A',
          stack: '1'
        },
        {
          label: Y`SMS usage` + ' (%)',
          backgroundColor: 'rgba(146,190,210, 0.6)',
          borderColor: 'rgba(146,190,210, 0.8)',
          borderWidth: 1,
          pointBackgroundColor: 'rgba(146,190,210, 0.8)',
          hoverBackgroundColor: 'rgba(146,190,210, 0.8)',
          hoverBorderColor: 'rgba(146,190,210, 1)',
          data: this.props.graph.graph.sms.map(sms =>
            Math.min(100.00, Number(sms * 100).toFixed(2))
          ),
          lineTension: 0,
          yAxisID: 'B',
          stack: '2'
        }
      ]
    }
  }
}

DataGraph = connect(mapStateToProps, mapDispatchToProps)(DataGraph)
DataGraph = withTheme()(DataGraph)
export default withStyles(Styles)(DataGraph)



// WEBPACK FOOTER //
// ./src/pages/subscription-details/containers/data-graph.js